import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { MenuItemStyles } from "./MenuItem.styles.js";
export var MenuItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MenuItemStyles.MenuItem, _extends({
    "data-testid": "menu-item"
  }, otherProps, {
    ref: ref,
    "aria-selected": !!otherProps.selected
  }), /*#__PURE__*/React.createElement(MenuItemStyles.Label, null, children), /*#__PURE__*/React.createElement(MenuItemStyles.SelectedIcon, {
    "data-testid": "menu-item-selected-icon",
    size: 20,
    id: undefined,
    $isVisible: !!otherProps.selected
  }));
});